export const GinVersion = '2.47.10';
export const GinBuild = '0000000267';
